'use strict';
/**
 * Dependencies
 * @ignore
 */

var _regeneratorRuntime = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var base64url = require('base64url');

var crypto = require('isomorphic-webcrypto');

var TextEncoder = require('../text-encoder');
/**
 * RSASSA-PKCS1-v1_5
 */


var RSASSA_PKCS1_v1_5 = /*#__PURE__*/function () {
  /**
   * constructor
   *
   * @param {string} bitlength
   */
  function RSASSA_PKCS1_v1_5(params) {
    _classCallCheck(this, RSASSA_PKCS1_v1_5);

    this.params = params;
  }
  /**
   * sign
   *
   * @description
   * Generate a digital signature for a given input and private key.
   *
   * @param {CryptoKey} key
   * @param {BufferSource} data
   *
   * @returns {Promise}
   */


  _createClass(RSASSA_PKCS1_v1_5, [{
    key: "sign",
    value: function sign(key, data) {
      var algorithm = this.params; // TODO
      //if (!this.sufficientKeySize()) {
      //  return Promise.reject(
      //    new Error(
      //      'A key size of 2048 bits or larger must be used with RSASSA-PKCS1-v1_5'
      //    )
      //  )
      //}

      data = new TextEncoder().encode(data);
      return crypto.subtle.sign(algorithm, key, data).then(function (signature) {
        return base64url(Buffer.from(signature));
      });
    }
    /**
     * verify
     *
     * @description
     * Verify a digital signature for a given input and private key.
     *
     * @param {CryptoKey} key
     * @param {BufferSource} signature
     * @param {BufferSource} data
     *
     * @returns {Promise}
     */

  }, {
    key: "verify",
    value: function verify(key, signature, data) {
      var algorithm = this.params;

      if (typeof signature === 'string') {
        signature = Uint8Array.from(base64url.toBuffer(signature));
      }

      if (typeof data === 'string') {
        data = new TextEncoder().encode(data);
      } // ...


      return crypto.subtle.verify(algorithm, key, signature, data);
    }
    /**
     * importKey
     *
     * @param {JWK} key
     * @returns {Promise}
     */

  }, {
    key: "importKey",
    value: function () {
      var _importKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key) {
        var jwk, algorithm, usages;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                jwk = Object.assign({}, key);
                algorithm = this.params;
                usages = key['key_ops'] || [];

                if (key.use === 'sig') {
                  usages.push('verify');
                }

                if (!(key.use === 'enc')) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", Promise.resolve(key));

              case 6:
                if (key.key_ops) {
                  usages = key.key_ops;
                }

                return _context.abrupt("return", crypto.subtle.importKey('jwk', jwk, algorithm, true, usages).then(function (cryptoKey) {
                  Object.defineProperty(jwk, 'cryptoKey', {
                    enumerable: false,
                    value: cryptoKey
                  });
                  return jwk;
                }));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function importKey(_x) {
        return _importKey.apply(this, arguments);
      }

      return importKey;
    }()
  }]);

  return RSASSA_PKCS1_v1_5;
}();
/**
 * Export
 */


module.exports = RSASSA_PKCS1_v1_5;